import React from "react";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import api from "../../../services/api";
import { Button, FormControl } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStoreActions } from "easy-peasy";
import { NoRowsOverlay, Checkbox } from "../../../components";
import DeleteIcon from "@mui/icons-material/Delete";
import { pt } from "yup-locale-pt";
import * as yup from "yup";
import DialogoEco from "./DialogoEco";

yup.setLocale(pt);

const Ecossistema = ({ ano, empresa, schema, useFormRef }) => {
  const { watch } = useFormRef;

  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);

  const [rows, setRows] = React.useState([]);
  const [openDlgEco, setOpenDlgEco] = React.useState(false);
  const [selectedEco, setSelectedEco] = React.useState();

  const loadEcossistemas = async mount => {
    startLoading();
    try {
      let getRows = (
        await api.http.get(`/09/ecossistema/empresa/${empresa}/${ano}`)
      ).data;
      if (!mount || mount.isMounted) setRows(getRows);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadEcossistemas(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [ano, empresa]);

  const deleteDados = React.useCallback(
    id => async () => {
      startLoading();
      try {
        await api.http.delete(`/09/ecossistema/empresa/${empresa}/${id}`);
        loadEcossistemas();
        stopLoading({ severity: 'success' });
      } catch (error) {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
    },
    []
  );

  const columns = React.useMemo(
    () => [
      {
        field: 'nomeStartup',
        headerName: 'Nome da Startup',
        flex: 1
      },
      {
        field: 'contatoStartup',
        headerName: 'Nome do contato',
        flex: 1
      },
      {
        field: 'emailStartup',
        headerName: 'Email do contato',
        flex: 1
      },
      {
        field: 'siteStartup',
        headerName: 'Website (Landing Page)',
        flex: 1
      },
      {
        field: 'numTrabFeitos',
        headerName: 'Número trabalhos feitos',
        flex: 1
      },
      {
        field: 'recomendoStartup',
        headerName: 'Recomendado',
        flex: 1,
        valueGetter: (value) => {
          return value ? "SIM" : "NÃO";
        },
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Remover',
        width: 100,
        getActions: params => [
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={deleteDados(params.id)}
          />
        ]
      }
    ],
    [deleteDados]
  );

  const novoRegistro = async () => {
    setOpenDlgEco(true);
  };

  const onCloseDlgEco = reload => {
    setOpenDlgEco(false);
    setSelectedEco(null);
    if (reload) {
      loadEcossistemas();
    }
  };

  const onRowClick = (params, event, details) => {
    setSelectedEco(params.row);
    setOpenDlgEco(true);
  };

  const disableEcossistema = () => {
    return ecoInteracStartups;
  };

  const ecoInteracStartups = watch('ecoInteracStartups');

  return (
    (<div>
      <FormControl fullWidth>
        <Checkbox
          sx={{ m: 1 }}
          field="ecoInteracStartups"
          schema={schema}
          useFormRef={useFormRef}
          disabled={rows.length > 0}
        />
      </FormControl>
      <DialogoEco
        empresa={empresa}
        ano={ano}
        selectedEco={selectedEco}
        open={openDlgEco}
        onClose={onCloseDlgEco}
      />
      <Grid style={{ textAlign: "right" }} size="grow">
        <Button
          color="primary"
          variant="outlined"
          onClick={novoRegistro}
          disabled={Boolean(disableEcossistema())}
        >
          Nova Startup
        </Button>
      </Grid>
      <DataGrid
        sx={{ height: 400, mt: 2 }}
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        onRowClick={onRowClick}
        slots={{ noRowsOverlay: NoRowsOverlay }}
        disableSelectionOnClick
      />
    </div>)
  );
};

export default Ecossistema;
